import Button from "react-bootstrap/Button";

function CHUkBusinessSolutionBody() {
  return (
    <>
      <div className="container-fluid  p-4 body-font">
        <div className="row p-4" style={{ backgroundColor: "ButtonHighlight" }}>
          <div
            className="col-12 col-md-8 mx-auto"
            style={{ position: "relative" }}
          >
            <img
              src="https://images.hertz.com/content/dam/hod/images/de-de/static/BusinessSolution_CH.png"
              alt="Business Solution"
              className="img-fluid"
              style={{ borderRadius: "16px", width: "100%" }}
            />
            <div
              style={{
                position: "absolute",
                top: "3%",
                left: "5%",
                color: "white",
                textShadow: "1px 1px 6px rgba(0,0,0,0.9)",
              }}
            >
              <p className="h6">
                <b>Business Solutions</b>
              </p>
              <h1>
                <i>
                  <b>Your business on the move!</b>
                </i>
              </h1>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12" style={{ textAlign: "center" }}>
            <p className="h2">Business Solutions</p>
            <br />
            <p>
              Hertz 24/7 Business offers you the most efficient way to manage your company’s vehicle needs. We have the right solution for you, whether you are a large corporation, a medium-sized business, or a small company. Thanks to award-winning technology in all our vehicles, we enable businesses to reduce costs, optimise vehicle usage, and improve fleet management.
            </p>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-md-6" style={{ textAlign: "center" }}>
            <img
              className="img-fluid"
              src="https://images.hertz.com/content/dam/hod/images/en-gb/static/Corda_Mobile.png"
              alt=""
            />
          </div>
          <div className="col-xs-12 col-md-6" style={{ textAlign: "left" }}>
            <div className="row">
              <div
                className="col-xs-12 col-md-12  py-md-5"
                sstyle={{ textAlign: "left" }}
              >
                <p className="h3">Cost-effective</p>
                <p>
                  By using a dedicated company fleet for car-sharing, businesses can potentially save costs compared to reimbursing individual employee journeys or using third-party services.
                </p>
              </div>
            </div>
            <div className="row">
              <div
                className="col-xs-12 col-md-12  py-md-5"
                style={{ textAlign: "left" }}
              >
                <p className="h3">Transparent and under control</p>
                <p>
                  Maintaining your own fleet provides greater transparency and control over your transport operations. You can track usage patterns, monitor vehicle maintenance, and enforce company policies more effectively.
                </p>
              </div>
            </div>
            <div className="row">
              <div
                className="col-xs-12 col-md-12  py-md-5"
                style={{ textAlign: "left" }}
              >
                <p className="h3">Environmentally friendly</p>
                <p>
                  Introducing a corporate car-sharing fleet can significantly reduce the environmental impact of employee travel. Companies can prioritise eco-friendly vehicles, such as hybrid or electric cars, helping to lower carbon emissions and support sustainability initiatives.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12" style={{ textAlign: "center" }}>
            <br />
            <p className="h2">Contact us to learn more</p>
            <br />
            <p>
              Send us an email (<b>✉:salesswitzerland@hertz.ch</b>), if you would like to find out more. A member of our corporate fleet team will get in touch with you.
            </p>
            <br />
            <p>
              <Button href="mailto:salesswitzerland@hertz.ch" variant="warning">
                <b>Send email</b>
              </Button>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default CHUkBusinessSolutionBody;
